import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class ExternalUrlResolver implements Resolve<void> {
  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const externalUrl: string = route.queryParams['externalUrl'];
    if (externalUrl?.length) {
      window.open(externalUrl, '_blank');
    }

    return EMPTY;
  }
}
